export const SupportedExtentions = [
  'doc',
  'docx',
  'jpg',
  'jpeg',
  'pdf',
  'xls',
  'xlsm',
  'xlsx',
  'msg',
  'wav',
  'mp4',
  'txt',
  'bmp'
];
